import { CodeEditor } from "../../form_components";
import { NodeTypeName } from "../../types";
import BaseDialog from "./BaseDialog";

/**
 * @see {NodeTypeName}s where `customScript` should be used instead of `script`.
 */
const customScriptTypes = new Set([
    NodeTypeName.dataAccess,
    NodeTypeName.dataAccessCompletion
]);

export default class CustomScriptDialog extends BaseDialog {
    /**
     * Editor dialog for editing custom function inside custom node
     * @module CustomScriptDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.onSave = this.onSave.bind(this);

        const node = this.props.context.props.context;
        const isReadOnly = (
            node.readOnly
            || this.props.context.props.disabled
            || this.props.context.props.functionType === "REUSEABLE"
        );
        const key = (customScriptTypes.has(node.props.nodeTypeName)) ? "customScript" : "script";
        const value = node.getConfig(key) ?? "";

        this.state = {
            key,
            isReadOnly,
            originalValue: value,
            value
        };
    }

    onSave() {
        const {
            key,
            originalValue,
            value
        } = this.state;

        if (value !== originalValue) {
            this.props.context.setConfig(key, value);

            if (this.props.context.props.context) {
                window.apm.postEventToCurrentView({
                    target: "request-refresh",
                    event: { id: this.props.context.props.context.getID(), type: "node" }
                });
            }
        }
        w2popup.close();
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.onSave);
    }

    unregister() {
        document.removeEventListener("ev-dialog-add", this.onSave);
    }

    render() {
        const {
            isReadOnly,
            value
        } = this.state;

        return (
            <div className="container-fluid">
                <div className="script-header selectable-text">
                    {this.props.context.getScriptHeader()}
                </div>
                <div className="script-wrapper">
                    <CodeEditor
                        onChange={(value) => {
                            this.setState({ value });
                        }}
                        readOnly={isReadOnly}
                        value={value}
                    />
                </div>
                <div className="script-footer">
                    {this.props.context.getScriptFooter()}
                </div>
            </div>
        );
    }
}